module.exports = __webpack_public_path__ + "static/img-a1-3351bc72cc277f23bae96789a05abbdc.png";